export const navScrollMenu = () => {
	
	const nav = document.querySelector(".header");
    const header = document.querySelector("header");
    const menuMobileBreakpoint = getComputedStyle(document.documentElement)
        .getPropertyValue("--breakpoint-menu-mobile")
        .trim();

	let mediaQuery = window.matchMedia(`(min-width: ${menuMobileBreakpoint})`);

	if (!nav || !header) return;

	if(!mediaQuery.matches) {
		if(window.scrollY >= 146) {
			nav.classList.add("--hover");
			header.classList.add("--hover");
		}
		return;
	};

	function headerClose (timeout = true) {
		if(timeout) {
			nav.classList.add("--hover-closing");
			setTimeout(() => {
				nav.classList.remove("--hover-closing");
				nav.classList.remove("--hover");
			}, 400);
		} else {
			nav.classList.remove("--hover");
		}
		header.classList.remove("--hover");
	}

	const headerOpen = () => {
		nav.classList.add("--hover");
		header.classList.add("--hover");
	}

    header.addEventListener("mouseenter", () => {
        if(window.scrollY <= 142) return;
        headerOpen();
    });

    header.addEventListener("mouseleave", () => {
		if(window.scrollY <= 142) return;
        headerClose();
    });

    let lastScrollTop = window.scrollY; 
    const scrollThreshold = 100;
    let lastDirection = null; // up or down
    window.addEventListener("scroll", () => {
        const currentScrollTop = window.scrollY;
        const scrollDelta = currentScrollTop - lastScrollTop;
		if (Math.abs(scrollDelta) > scrollThreshold && window.scrollY > 340) {
			let currentDirection = scrollDelta > 0 ? "down" : "up";
			//console.log(window.scrollY, window.scrollY, scrollDelta, currentDirection, lastDirection);
			if (currentDirection !== lastDirection) {
				// Direction changed
				if (currentDirection == "down") {
					headerClose();
				} else {
					headerOpen();
				}
				lastDirection = currentDirection;
			}
            lastScrollTop = currentScrollTop;
        } else if (window.scrollY <= 340 && header.classList.contains("--hover")) {
			headerClose();
			lastDirection = null;
			lastScrollTop = currentScrollTop;
		}
    }, { passive: false });
}